module.exports = __webpack_public_path__ + "img/zi_3.65a10749.png";